import React from 'react';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import Container from '../../components/container/Container';
import TextEditor from '../../components/form/TextEditor';
import Button from '../../components/buttons/Button';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import Random from "../../utils/strings/Random";
import LoadingPage from '../../components/loading/LoadingPage';

import './page.css';

const URL_SAVE = WS.termos.save;
const URL_DETAIL = WS.termos.detalhe;

const PAGE = 'termos-de-uso';

class TermosUso extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE],
      text: '' ,
      editor: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {
      atencao,
      erroLoad
    }
    = this.state.strings;

    const self = this;

    Requisitions({
      url:URL_DETAIL,
      data: {page: PAGE},
      sucess:function(data){
        self.setState({
          text: data.item.conteudo,
          isLoading: true
        });
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroLoad
        });
      }
    });
  }

  handleChange(value) {
    this.setState({ text: value });
  }

  handleSubmit(e){
    e.preventDefault();

    const texto = this.state.text;

    const {
      atencao,
      salvoSucesso,
      erroSalvar
    }
    = this.state.strings;

    Requisitions({
      url:URL_SAVE,
      data: {conteudo: texto, page: PAGE},
      sucess:function(data){
        var msg;

        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);

      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  getForm = () => <form id={this.state.wrapper} onSubmit={this.handleSubmit}>
    <TextEditor
      onChange={this.handleChange}
      text={this.state.text}
    />
    <br/><br/>
    <div className="box-right-button"><Button type="submit" text={this.state.strings.salvar} classes="bt-save bt-blue" /></div>
  </form>;

  render() {
    let wrapper = !this.state.isLoading ? <LoadingPage /> : this.getForm() ;
    const {
      titleTermos
    } = this.state.strings;
    return (
      <Container>
        <MainTitle title={titleTermos}></MainTitle>
        {wrapper}
      </Container>
    );
  }
}

export default TermosUso;



// WEBPACK FOOTER //
// ./src/classes/termos-uso/TermosUso.js